import { CanActivateFn } from '@angular/router';

export const subAgentGuard: CanActivateFn = () => {
    const isSubAgent = localStorage.getItem('isSubAgent') === 'true';
    return isSubAgent ? false : true;
};
